import React from "react";
import styled from "styled-components";
import images, { imagesOrdered } from "../assets/viz";
import { breakpoints } from "../styles";

interface Props {
    prediction: number[];
}

const thresholding = (prediction: number[]) => {
    const colorOverlays = prediction.map((p, idx) => {
        if (idx === 6) return null;
        const image = imagesOrdered[idx];
        if (p >= 0.75) return image.r;
        if (p >= 0.4) return image.y;
        if (p >= 0.1) return image.b;
        return null;
    });
    return colorOverlays;
};

export const HeartViz = ({ prediction }: Props) => {
    const colorOverlays = thresholding(prediction);
    return (
        <Container>
            <ImageLayer src={images.heart} alt="heart" />
            {colorOverlays.map((overlay) => {
                if (!overlay) return null;
                return <ImageLayer src={overlay} alt="overlay" />;
            })}
        </Container>
    );
};

const Container = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    flex: 2;

    @media ${breakpoints.md} {
        min-height: 30vh;
    }
`;

const ImageLayer = styled.img`
    position: absolute;
    max-height: 100%;
`;
